import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "decimal"
})
export class DecimalPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    if (typeof value === "number") {
      return value.toLocaleString("de-DE");
    } else if (typeof value === "string") {
      const numberValue = parseFloat(value);
      return numberValue.toLocaleString("de-DE");
    } else {
      return "-";
    }
  }
}
